<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="1200px">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" color="dark">mdi-square-edit-outline</v-icon>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Edit Article</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-form @submit="updateFaq()" v-model="valid" ref="form">
          <v-layout wrap class="mx-5 my-5 wrap justify-md-end">
            <v-flex xs12 sm4 md2 class="mt-4">
              <h4 class="text-body-2 dark--text">Show Order</h4>
            </v-flex>
            <v-flex xs12 sm8 md2 class="mt-4">
              <v-text-field v-model="data.showOrder" :rules="[requiredValidator('showOrder')]" type="number" solo dense></v-text-field>
            </v-flex>
          </v-layout>

          <v-card-text>
            <v-container class="">
              <v-card-text>
                <v-card height="600">
                  <v-layout wrap class="mx-10 my-5 ">
                    <v-flex xs12 sm4 md2 class="mt-4">
                      <h4 class="text-body-2 dark--text">Heading En</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md10 class="mt-4">
                      <v-text-field v-model="data.headingEn" solo dense></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap class="mx-10 my-5 ">
                    <v-flex xs12 sm4 md2 class="mt-4">
                      <h4 class="text-body-2 dark--text">Heading Ar</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md10 class="mt-4">
                      <v-text-field v-model="data.headingAr" solo dense></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap class="mx-10 my-5">
                    <v-flex xs12 sm3 md2 class="mt-2">
                      <h4 class="text-body-2 dark--text">Image (Web)</h4>
                    </v-flex>
                    <v-img v-if="!updateHeaderImageWeb" class="light--text align-end" :width="200" :height="130" :src="imageUrl + data.headingImage">
                      <v-btn v-if="!updateHeaderImageWeb" small @click="changeHeaderImageWeb" tile>
                        <v-icon dark>mdi-pencil</v-icon>
                      </v-btn>
                    </v-img>
                    <v-flex xs12 md2 v-if="updateHeaderImageWeb">
                      <h4 class="text-body-2 dark--text">Select Image</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md3 v-if="updateHeaderImageWeb">
                      <input type="file" accept="image/*" @change="onFileSelected($event)" />
                    </v-flex>
                    <v-snackbar v-model="snackbar" :timeout="3000">
                      {{ snackText }}
                    </v-snackbar>
                  </v-layout>

                  <v-layout wrap class="mx-10 my-5 mb-5">
                    <v-flex xs12 sm3 md2 class="mt-2">
                      <h4 class="text-body-2 dark--text">Image (Mobile)</h4>
                    </v-flex>
                    <v-img v-if="!updateHeaderImageMob" class="light--text align-end" :width="200" :height="130" :src="imageUrl + data.headingImageMob">
                      <v-btn v-if="!updateHeaderImageMob" small @click="changeHeaderImageMob" tile>
                        <v-icon dark>mdi-pencil</v-icon>
                      </v-btn>
                    </v-img>
                    <v-flex xs12 md2 v-if="updateHeaderImageMob">
                      <h4 class="text-body-2 dark--text">Select Image</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md6 v-if="updateHeaderImageMob">
                      <input type="file" accept="image/*" @change="onFileSelectedMob($event)" />
                    </v-flex>
                    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                      {{ snackText }}
                    </v-snackbar>
                  </v-layout>
                </v-card>

                <v-card-subtitle class="pa-3">
                  <span class="text-h6 dark--text">Paragraph</span>
                  <v-spacer></v-spacer>
                </v-card-subtitle>

                <v-row v-for="(item, index) in subHeadings" :key="index">
                  <v-col cols="10">
                    <v-card>
                      <v-layout class="mx-3 mt-4">
                        <v-flex xs12 sm4 md2 class="mt-3">
                          <h4 class="text-body-2 dark--text">Title En</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md10 class="mt-3">
                          <v-text-field v-model="item.titleEn" :rules="[requiredValidator('titleEn')]" solo dense></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mx-3 mt-4">
                        <v-flex xs12 sm4 md2 class="mt-3">
                          <h4 class="text-body-2 dark--text">Title Ar</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md10 class="mt-3">
                          <v-text-field v-model="item.titleAr" :rules="[requiredValidator('title Ar')]" solo dense></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mx-3 my-4">
                        <v-flex xs12 sm4 md2 class="mt-2">
                          <h4 class="text-body-2 dark--text">description En</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md10>
                          <client-only>
                            <VueEditor v-model="item.descriptionEn" />
                          </client-only>
                        </v-flex>
                      </v-layout>
                      <v-layout class="mx-3 my-4">
                        <v-flex xs12 sm4 md2 class="mt-2">
                          <h4 class="text-body-2 dark--text">description Ar</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md10>
                          <client-only>
                            <VueEditor v-model="item.descriptionAr" />
                          </client-only>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mx-3 mt-6 ">
                        <v-flex xs12 sm3 md2>
                          <h4 class="text-body-2 dark--text">Image (Web)</h4>
                        </v-flex>
                        <v-img v-if="!item.updateParagraphImageWeb" class="light--text align-end" :width="200" :height="130" :src="imageUrl + item.image">
                          <v-btn v-if="!item.updateParagraphImageWeb" small @click="changeParaImageWeb(item)" tile>
                            <v-icon dark>mdi-pencil</v-icon>
                          </v-btn>
                        </v-img>
                        <v-flex xs12 sm8 md3 class="mt-4" v-if="item.updateParagraphImageWeb">
                          <input type="file" accept="image/*" @change="onFileSelected($event, item)" />
                        </v-flex>

                        <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                          {{ snackText }}
                        </v-snackbar>
                      </v-layout>
                      <v-layout class="mx-3 mt-5 mb-5">
                        <v-flex xs12 sm3 md2 class="mt-2 ">
                          <h4 class="text-body-2 dark--text">Image (Mobile)</h4>
                        </v-flex>
                        <v-img v-if="!item.updateParagraphImageMob" class="light--text align-end" :width="200" :height="130" :src="imageUrl + data.imageMob">
                          <v-btn v-if="!item.updateParagraphImageMob" small @click="changeParaImageMob(item)" tile>
                            <v-icon dark>mdi-pencil</v-icon>
                          </v-btn>
                        </v-img>
                        <v-flex xs12 sm8 md6 class="mt-5 mb-5" v-if="item.updateParagraphImageMob">
                          <input type="file" accept="image/*" @change="onFileSelectedMob($event, item)" />
                        </v-flex>
                        <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                          {{ snackText }}
                        </v-snackbar>
                      </v-layout>
                      <v-layout>
                        <v-flex xs12 sm3 md3 class="mt-2 ">
                          <h4 class="text-body-2 dark--text">Image Position</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md6 class="mt-4">
                          <v-row>
                            <v-radio-group v-model="item.imagePosition">
                              <v-radio label="Top" value="TOP"></v-radio>
                              <v-radio label="Bottom" value="BOTTOM"></v-radio>
                            </v-radio-group>
                          </v-row>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-col>
                  <v-col>
                    <div class="mt-5">
                      <v-btn v-if="index == 0" @click="createParagraph" class="light--text" text color="primary"> <v-icon class="" large>mdi-plus</v-icon> </v-btn>
                      <v-btn v-else @click="removeParagraph(item)" class="light--text" text color="error"> <v-icon class="" large>mdi-minus</v-icon> </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-layout>
                  <v-flex xs12 sm4 md3>
                    <h4 class="dark--text text-body-2">Currently Active</h4>
                  </v-flex>
                  <v-flex xs12 sm8 md9>
                    <v-radio-group row v-model="data.isActive">
                      <v-radio label="Yes" :value="true"></v-radio>
                      <v-radio label="No" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions class="justify-end mt-n8">
          <v-btn color="primary" class="mb-2 light--text mb-sm-4 text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="updateForm" :loading="btnloading" :disabled="!valid">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";
import { VueEditor } from "vue2-editor";
export default {
  components: { VueEditor },
  props: {
    dataInfo: {
      required: true,
    },
  },
  data() {
    return {
      btnloading: false,
      valid: true,
      errors: [],
      text: "",
      showOrder: 0,
      active: true,
      show_dialog_box: false,
      requiredValidator: requiredValidator,
      imageUrl: process.env.VUE_APP_BASE_URL,
      imagePosition: "",
      paragraphs: [],
      headingImage: null,
      headingImageMob: null,
      image: null,
      imageMob: null,
      updateParagraphImageWeb: false,
      updateHeaderImageWeb: false,
      updateHeaderImageMob: false,
      snackbar: false,
      snackText: "",
      snackColor: "",
      subHeadings: [],
    };
  },
  created() {
    this.data = JSON.parse(JSON.stringify(this.dataInfo));
    this.data.subHeadings.forEach(element => {
      element.updateParagraphImageWeb = false;
      element.updateParagraphImageMob = false;
    });
    this.subHeadings = this.data.subHeadings;
  },
  methods: {
    removeParagraph(item) {
      this.data.subHeadings = this.subHeadings.filter(x => x._id != item._id);
    },
    createParagraph() {
      let paragraph = {
        titleEn: "",
        titleAr: "",
        descriptionEn: "",
        descriptionAr: "",
        image: null,
        imageMob: null,
        _id: this.subHeadings.length + 1,
      };
      this.subHeadings.push(paragraph);
    },
    close() {
      this.show_dialog_box = false;
    },
    updateForm() {
      this.btnloading = true;
      let paragraphs = new Array();
      this.subHeadings.forEach(element => {
        let paragraph = {
          titleEn: element.titleEn,
          titleAr: element.titleAr,
          descriptionEn: element.descriptionEn,
          descriptionAr: element.descriptionAr,
          image: element.newImage ? element.newImage : null,
          imageMob: element.newImageMob ? element.newImageMob : null,
          imagePosition: element.imagePosition,
          id: isNaN(element._id) ? element._id : null,
        };
        paragraphs.push(paragraph);
      });

      this.$apollo
        .mutate({
          mutation: require("../api/updateArticle.graphql"),
          variables: {
            id: this.data._id,
            headingEn: this.data.headingEn,
            headingAr: this.data.headingAr,
            headingImage: this.headingImage,
            headingImageMob: this.headingImageMob,
            showOrder: parseInt(this.data.showOrder),
            subHeadings: paragraphs,
            isActive: this.data.isActive,
          },
          update: () => {
            this.$root.$emit("updateArticle");
            // this.$refs.form.reset();
            this.btnloading = false;
            this.show_dialog_box = false;
          },
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
        });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    changeParaImageWeb(item) {
      debugger;
      let row = this.subHeadings.find(x => x._id == item._id);
      row.updateParagraphImageWeb = true;
    },
    changeParaImageMob(item) {
      let row = this.subHeadings.find(x => x._id == item._id);
      row.updateParagraphImageMob = true;
    },
    changeHeaderImageWeb() {
      this.updateHeaderImageWeb = true;
    },
    changeHeaderImageMob() {
      this.updateHeaderImageMob = true;
    },
    getImage() {
      if (this.data.packageImage) return this.imageUrl + this.data.packageImage;
      else return require("../../assets/no-image.png");
    },
    onFileSelected(event, item) {
      if (item) {
        let row = this.subHeadings.find(x => x._id == item._id);
        row.newImage = event.target.files[0];
      } else {
        const selectedFile = event.target.files[0];
        this.headingImage = selectedFile;
      }
    },
    onFileSelectedMob(event, item) {
      if (item) {
        let row = this.subHeadings.find(x => x._id == item._id);
        row.newImageMob = event.target.files[0];
      } else {
        const selectedFile = event.target.files[0];
        this.headingImageMob = selectedFile;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
